import { Reducer } from "redux";
import SellingSpot from "../../models/selling/SellingSpot";
import { GetSellingSpotsActionTypes } from "./types";

export interface SellingState {
    sellingSpots?: SellingSpot[]
}

const unloadedState: SellingState = { sellingSpots: undefined };

export const sellingReducer: Reducer<SellingState> = (state: SellingState | undefined, action): SellingState => {
    if (!state) {
        return unloadedState;
    }

    switch (action.type) {
        case GetSellingSpotsActionTypes.SUCCESS:
            return { ...state, sellingSpots: [...action.payload] };
        default:
            return state;
    }
};
